import { ViewConfig } from "@lib/views";
import type { PersonalAccessToken } from "@common/schemas/domains/personalAccessToken/personal-access-token.schema";
import { TokenActionsCell } from "./cells/TokenActionsCell";
import { TokenDateCell } from "./cells/TokenDateCell";
import { TokenPermissionsCell } from "./cells/TokenPermissionsCell";
import { TokenPrefixCell } from "./cells/TokenPrefixCell";
import { TokenStatusCell } from "./cells/TokenStatusCell";

export enum McpCliTokenColumn {
    NAME = "name",
    PREFIX = "prefix",
    PERMISSIONS = "permissions",
    STATUS = "status",
    CREATED = "createdAt",
    LAST_USED = "lastUsedAt",
    EXPIRES = "expiresAt",
    ACTIONS = "actions",
}

export type McpCliTokenRow = PersonalAccessToken;

export const mcpCliTokensViewConfig: ViewConfig<
    McpCliTokenRow,
    McpCliTokenColumn,
    never
> = {
    columns: {
        [McpCliTokenColumn.NAME]: {
            accessorKey: "name",
            name: "Name",
            header: "Name",
            minSize: 160,
            maxSize: 320,
        },
        [McpCliTokenColumn.PREFIX]: {
            accessorKey: "prefix",
            name: "Prefix",
            header: "Prefix",
            cell: TokenPrefixCell,
            minSize: 160,
            maxSize: 160,
        },
        [McpCliTokenColumn.PERMISSIONS]: {
            accessorKey: "permissions",
            name: "Permissions",
            header: "Permissions",
            cell: TokenPermissionsCell,
            minSize: 130,
            maxSize: 180,
        },
        [McpCliTokenColumn.STATUS]: {
            accessorKey: "revokedAt",
            name: "Status",
            header: "Status",
            cell: TokenStatusCell,
            minSize: 100,
            maxSize: 140,
        },
        [McpCliTokenColumn.CREATED]: {
            accessorKey: "createdAt",
            name: "Created",
            header: "Created",
            cell: TokenDateCell,
            minSize: 120,
            maxSize: 160,
        },
        [McpCliTokenColumn.LAST_USED]: {
            accessorKey: "lastUsedAt",
            name: "Last used",
            header: "Last used",
            cell: TokenDateCell,
            minSize: 120,
            maxSize: 160,
        },
        [McpCliTokenColumn.EXPIRES]: {
            accessorKey: "expiresAt",
            name: "Expires",
            header: "Expires",
            cell: TokenDateCell,
            minSize: 100,
            maxSize: 140,
        },
        [McpCliTokenColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: TokenActionsCell,
            minSize: 90,
            maxSize: 90,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
